import about from '../assets/project/about.gif';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const About = () => {
  const { ref, inView } = useInView({
    threshold: 0.2, // Trigger when 20% of the component is visible
    triggerOnce: true // Only trigger once
  });

  return (
    <motion.section
      id='about'
      className='bg-[#1C1C1C] text-white w-full min-h-screen  md:pt-5 lg:pt-5 xl:h-screen '
      initial={{ opacity: 0 }}
      animate={inView ? { opacity: 1 } : { opacity: 0 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      ref={ref} >
        
      <div className='flex flex-col justify-center mx-auto max-w-scr h-full w-full px-4 lg:px-24 xl:px-60'>
        <div className='flex flex-col justify-center pt-5 md:mt-0'>
          <motion.h2
            className='text-4xl font-bold  mb-5 flex justify-center'
            initial={{ y: -50, opacity: 0 }}
            animate={inView ? { y: 0, opacity: 1 } : { y: -50, opacity: 0 }}
            transition={{ delay: 0.2, type: 'spring', stiffness: 300, damping: 20 }}>
            <span className='border-b-4 border-gray-500 '>About Me</span>
          </motion.h2>

          <div className='flex justify-center items-center flex-wrap'>
            <motion.p
              className='md:text-xl tracking-wider flex-1 p-10 w-full'
              initial={{ x: -50, opacity: 0 }}
              animate={inView ? { x: 0, opacity: 1 } : { x: -50, opacity: 0 }}
              transition={{ delay: 0.2, type: 'spring', stiffness: 300, damping: 20 }}>
           MERN Stack Developer with a proven track record in architecting cost-effective internal tools and high-performance applications. Transitioned from a non-IT background to becoming the <span className='text-[#F16A6A] font-bold'>Employee of the Month (Feb 2026)</span> at 7Eagles and securing <span className='text-[#F16A6A] font-bold'>1st Prize</span> at the CognoRise Hackathon. Passionate about engineering scalable full-stack solutions and optimizing user experiences.
            </motion.p>
            <p className='flex-2'>
              <motion.img 
                src={about}
                alt="About Mugunthan - MERN Stack Developer"
                className='w-full h-auto'
                initial={{ scale: 0.5, opacity: 0 }}
                animate={inView ? { scale: 1, opacity: 1 } : { scale: 0.5, opacity: 0 }}
                transition={{ delay: 0.6, duration: 0.5, type: 'spring', stiffness: 300, damping: 20 }}/>
            </p>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default About;
